import { createContext } from 'react';
export const EntityEditorDispatchContext = createContext({
    defaultContextValue: true,
});
EntityEditorDispatchContext.displayName = 'EntityEditorDispatchContext';
//# sourceMappingURL=EntityEditorDispatchContext.js.map